import Transport from 'pages/transport/Transport';
import LoginPage from 'pages/login/LoginPage';
import {
	Route,
} from 'react-router-dom';

export interface ContentViewInterface {
  id: string,
  path: string,
  name: string,
  element: JSX.Element,
}

export const ContentViews = {
	TRANSPORT: {
		id: '0',
		path: '/app',
		name: 'Transport',
		element: <Transport />,
	},
	LOGIN: {
		id: '1',
		path: '/app/login',
		name: 'Login',
		element: <LoginPage />,
	},
}
/**
 * Returns the Route objects
 * for the ContentViews
 */
export const getRoutes = () =>
	Object.entries(ContentViews).map(
		// eslint-disable-next-line unused-imports/no-unused-vars
		([k, view]: [string, ContentViewInterface]) =>
			(<Route key={view.id} path={view.path} element={view.element}/>));